var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('div',{staticClass:"container mt-6"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.close),expression:"close"}],class:[
          _vm.loginInfo.name == 'admin' && _vm.loginInfo.stat == true
            ? 'admin'
            : 'col-sm-12 col-md-3' ]},[_c('PriceList')],1),_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }